import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { fetchJobApplications, type JobApplication } from './api';
import './Admin.css';

export default function AdminApplications() {
  const { id } = useParams<{ id: string }>();
  const [applications, setApplications] = useState<JobApplication[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!id) return;
    let cancelled = false;
    (async () => {
      try {
        const apps = await fetchJobApplications(id);
        if (!cancelled) {
          setApplications(apps);
          setLoading(false);
        }
      } catch (err: any) {
        if (!cancelled) {
          setError('Failed to load applications');
          setLoading(false);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [id]);

  return (
    <div className="admin-page">
      <header className="admin-page-header">
        <div>
          <h1>Job Applications</h1>
          <p className="admin-muted">View candidates who applied for this role.</p>
        </div>
        <Link to="/admin/careers" className="admin-btn admin-btn-secondary">
          Back to Careers
        </Link>
      </header>

      {error && <p className="admin-error">{error}</p>}

      <div className="admin-card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h2 style={{ margin: 0, fontSize: '1.25rem' }}>Candidates</h2>
          <span className="admin-muted">{applications.length} Applicants</span>
        </div>
        
        {loading ? (
          <p>Loading applications...</p>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email & Phone</th>
                  <th>Applied On</th>
                  <th>Cover Letter</th>
                  <th>CV / Resume</th>
                </tr>
              </thead>
              <tbody>
                {applications.length === 0 ? (
                  <tr>
                    <td colSpan={5} style={{ textAlign: 'center' }}>No applications received yet.</td>
                  </tr>
                ) : (
                  applications.map(app => (
                    <tr key={app._id}>
                      <td><strong>{app.name}</strong></td>
                      <td>
                        <div><a href={`mailto:${app.email}`} style={{ color: '#60a5fa' }}>{app.email}</a></div>
                        {app.phone && <div style={{ fontSize: '13px', color: '#94a3b8', marginTop: '4px' }}>{app.phone}</div>}
                        {app.portfolio && <div style={{ fontSize: '13px', marginTop: '4px' }}><a href={app.portfolio} target="_blank" rel="noreferrer" style={{ color: '#ea580c' }}>Portfolio</a></div>}
                      </td>
                      <td>{new Date(app.appliedAt).toLocaleString()}</td>
                      <td>
                        <div style={{ maxWidth: '300px', maxHeight: '100px', overflowY: 'auto', fontSize: '13px', color: '#cbd5e1' }}>
                          {app.coverLetter}
                        </div>
                      </td>
                      <td>
                        <a 
                          href={`http://localhost:4000${app.cvUrl}`} 
                          target="_blank" 
                          rel="noreferrer" 
                          className="admin-btn admin-btn-primary" 
                          style={{ padding: '6px 12px', fontSize: '12px' }}
                        >
                          View PDF
                        </a>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
